import { CircularProgress } from '@mui/material'
import { Box } from '@mui/material'

export const LoadingDisplay = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
    <CircularProgress color="primary" />
  </Box>
)
